var _defineProperty = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _toConsumableArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var camelCase = require('lodash.camelcase');

var queryString = require('qs'); // Replace path parameters and query parameters in the URI, using the OpenAPI
// definition


var getUrl = function getUrl(_ref, basePath, requestParams) {
  var path = _ref.path,
      parameters = _ref.parameters;
  var url = "".concat(basePath).concat(path);
  var urlA = addPathParams(url, parameters, requestParams);
  var urlB = addQueryParams(urlA, parameters, requestParams);
  return urlB;
};

var addPathParams = function addPathParams(url, parameters, requestParams) {
  var pathParams = getRequestParams(parameters.path, requestParams, 'path variable');
  return Object.entries(pathParams).reduce(addPathParam, url);
};

var addPathParam = function addPathParam(url, _ref2) {
  var _ref3 = _slicedToArray(_ref2, 2),
      name = _ref3[0],
      value = _ref3[1];

  return url.replace("{".concat(name, "}"), value);
};

var addQueryParams = function addQueryParams(url, parameters, requestParams) {
  var queryParams = getRequestParams(parameters.query, requestParams, 'query variable');

  if (Object.keys(queryParams).length === 0) {
    return url;
  }

  return "".concat(url, "?").concat(queryString.stringify(queryParams));
};

var getRequestParams = function getRequestParams(params, requestParams, name) {
  var entries = Object.values(params).map(function (param) {
    return getRequestParam(param, requestParams, name);
  });
  return Object.assign.apply(Object, [{}].concat(_toConsumableArray(entries)));
};

var getRequestParam = function getRequestParam(param, requestParams, name) {
  var value = requestParams[param.name] || requestParams[camelCase(param.name)];

  if (value !== undefined) {
    return _defineProperty({}, param.name, value);
  }

  if (param.required) {
    throw new Error("Missing required ".concat(name, " '").concat(param.name, "'"));
  }
};

module.exports = {
  getUrl: getUrl
};